import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {NotasInseridas} from '@/model/resource/NotasInseridas'

export class ListNotasInseridasSchema extends Schema {
  readonly name = 'ListNotasInseridas'

  readonly fieldSet: FieldSet<NotasInseridas> = {
    nomeFantasia: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content:
          schema.model.responsavel && schema.model.responsavel.nomeFantasia
            ? schema.model.responsavel.nomeFantasia
            : schema.model.responsavel?.razaoSocial ?? '-',
      },
    }),
  }
}
